module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticClass: "title is-5 has-text-white module-name"
  }, [(_vm.currentLand && _vm.currentLand.areaLevel > 1) ? _c('a-icon', {
    attrs: {
      "type": "rollback"
    },
    on: {
      "click": _vm.toHigherLand
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLand ? (_vm.currentLand.manorName || _vm.currentLand.areaName) + '（' + _vm.currentLand.areaLevel + '级）' : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel < 4) ? _c('div', {
    staticClass: "land-add"
  }, [_c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.showLandDetailModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.addLandBtnText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "land-list"
  }, _vm._l((_vm.landList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "land-item",
      on: {
        "click": function($event) {
          return _vm.showLandDetailModal(item)
        }
      }
    }, [_vm._v(_vm._s(item.manorName || item.areaName))])
  }), 0), _vm._v(" "), _c('LandDetail', {
    ref: "detail",
    attrs: {
      "visible": _vm.detailVisible,
      "areaLevel": _vm.currentLand ? _vm.currentLand.areaLevel : 0,
      "hasBtn": _vm.currLowerLand ? true : false
    },
    on: {
      "delete": _vm.handleLandDelete,
      "cancel": function($event) {
        _vm.detailVisible = false
      },
      "submit": _vm.handleLandSubmit,
      "to-lower": _vm.toLowerLand
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53fba496","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Land.vue
// module id = 1075
// module chunks = 1